import { collection, doc, getDoc, getDocs, getFirestore, orderBy, Query, query, where } from "firebase/firestore"
import { articleConverter } from "../converters/articleConverter";
import { Article } from "../types/Article";

export const queryArticles = async (isPublished: boolean) => {
    const db = getFirestore();

    let q: Query<Article>;
    
    if (isPublished) {
        q = query(
            collection(db, 'Articles'),
            where('isPublished', '==', isPublished),
            orderBy('publishedTime', 'desc')
        ).withConverter(articleConverter);
    } else {
        q = query(
            collection(db, 'ArticlesDrafts'),
            orderBy('lastUpdate', 'desc')
        ).withConverter(articleConverter);
    }

    return (await getDocs(q)).docs.map(d => d.data());
};

export const queryFeaturedArticles = async () => {
    const db = getFirestore();

    const q = query(
        collection(db, 'Articles'),
        where('isPublished', '==', true),
        where('isFeatured', '==', true),
        orderBy('isFeaturedOrder', 'asc')
    ).withConverter(articleConverter)

    return (await getDocs(q)).docs.map(d => d.data());
};

export const queryArticle = async (articleId: string) => {
    const db = getFirestore();
    return (await getDoc(doc(db, `Articles/${articleId}`).withConverter(articleConverter))).data();
};

export const queryArticleDraft = async (articleId: string) => {
    const db = getFirestore();
    return (await getDoc(doc(db, `ArticlesDrafts/${articleId}`).withConverter(articleConverter))).data();
};